/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const publishedCollectionSlugSchema = z.object({
  id: z.number(),
  slug: z.string(),
  updatedAt: z.number(),
});

export type IPublishedCollectionSlugItem = z.infer<typeof publishedCollectionSlugSchema>;

export const listPublicCollectionSlugsV2ResponseSchema = z.object({
  success: z.boolean(),
  data: z.array(publishedCollectionSlugSchema),
  pagination: z.object({
    nextCursor: z.string().nullable(),
    hasMore: z.boolean(),
  }),
});

export type IListPublicCollectionSlugsV2Response = z.infer<
  typeof listPublicCollectionSlugsV2ResponseSchema
>;
